
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function tryCaptureStackTrace<T extends Error>(targetObject: T, constructorOpt?: Function): T {
  try {
    if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(targetObject, constructorOpt);
    }
  } catch {
    // ignore
  }
  return targetObject;
}
